import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import VehicleRegistrationComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationFullComponent.vue";
import {onMounted, reactive, ref} from "vue";
import {storeToRefs} from "pinia";
import {useAccountStore} from "@/stores/accountStore";
import apiVehicleRegistration from "@/modules/VehicleRegistration/api";
import GdvMessageIdComponent from "@/modules/VehicleRegistration/components/GdvMessageIdComponent.vue";
import VehicleRegistrationSuggestionComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationSuggestionComponent.vue";
import SogCardActionDropDownButton from "@/shared/ui/SogCardActionDropDownButton.vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import apiRegistrationInquiry from "@/modules/RegistrationInquiry/api";
import {registrationInquiryMailTypeItems} from "@/modules/RegistrationInquiry/mailTypeItems";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import MemoComponent from "@/modules/VehicleRegistration/components/MemoComponent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import notificationService from "@/shared/services/NotificationService";
import TempFileFormComponent from "@/modules/FileUtils/components/TempFileFormComponent.vue";
import ListFile from "@/shared/model/ListFile";
import FileCardComponent from "@/modules/FileUtils/components/FileCardComponent.vue";
import HistoryListComponent from "@/modules/History/components/HistoryListComponent.vue";
import History from "@/shared/model/History";
import apiHistory from "@/modules/History/api";
import apiFileUtils from "@/modules/FileUtils/api";
import apiFile from "@/shared/services/apiFile";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import getGuid from "@/shared/utils/getGuid";
import VehicleRegistration from "@/shared/model/VehicleRegistration";
import {useNavigationStore} from "@/modules/Navigation/store";
import MemoEditComponent from "@/modules/VehicleRegistration/components/MemoEditComponent.vue";
import SogDialog from "@/shared/ui/SogDialog.vue";
import {SogDialogButtons} from "@/shared/ui/types/SogDialogButtons";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import VehicleRegistrationLinkDialog
  from "@/modules/VehicleRegistration/components/VehicleRegistrationLinkDialog.vue";

interface Props {
  id?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationDetailsPage',
  props: {
    id: { default: undefined }
  },
  setup(__props: any) {


const props = __props

const _navigationStore = useNavigationStore()
const {isRoot: _isRoot} = storeToRefs(useAccountStore())
const vehicleRegistrationId = ref<string | undefined>(undefined)
const _gdvMessageIds = ref<string[]>([])
const _memos = ref<string>("")
const _history: History[] = reactive<History[]>([])
const _vehicleRegistration = ref<VehicleRegistration | undefined>(undefined)
const _form = ref<InstanceType<typeof MemoEditComponent> | null>(null)
const _loadDetails = ref(true)
const _loadFiles = ref(true)
const _loadHistory = ref(true)
const _key = ref("")
const _editMemoVisible = ref(false)
const _tempFileInfo = ref<{ id?: string, fileName?: string, name?: string } | undefined>(undefined)
const _uploadTempFile = ref(false)
const _uploader = ref<InstanceType<typeof TempFileFormComponent> | null>(null)
const _camera = ref(false)
const _tempFile = ref<ListFile[]>([])
const _spinner = useSpinner()
const _memo = ref<string | undefined>(undefined)
const _reason = ref<string | undefined>("")
const _dialogUnlink = ref<InstanceType<typeof SogDialog> | null>(null)

async function load() {

  if (!_navigationStore.currentVehicleRegistrationId && !props.id) {
    return
  }
  vehicleRegistrationId.value = props.id ?? _navigationStore.currentVehicleRegistrationId

  _key.value = getGuid();
  const t_loadDetails = loadDetails(_key.value);
  const t_loadFiles = loadFiles(_key.value);
  const t_loadHistory = loadHistory(_key.value);

  await Promise.allSettled([t_loadDetails, t_loadFiles, t_loadHistory])
}

async function loadFiles(key: string) {
  if (!vehicleRegistrationId.value) {
    return
  }
  _loadFiles.value = true
  try {

    const listFile = await apiFileUtils.listFileStore(vehicleRegistrationId.value)

    if (_key.value !== key) {
      return
    }
    _tempFile.value = listFile?.sort((a, b) => (a.date && b.date) ? Date.parse(b.date.toString()) - Date.parse(a.date.toString()) : 0) ?? [];
  } finally {
    _loadFiles.value = false
  }
}

async function loadHistory(key: string) {
  if (!vehicleRegistrationId.value)
    return
  _loadHistory.value = true
  _history.length = 0
  const lst = await apiHistory.listVehicleRegistration(vehicleRegistrationId.value)
  if (_key.value !== key) {
    return
  }

  if (lst) {
    _history.push(...lst)
  }
  _loadHistory.value = false
}


async function loadDetails(key: string) {
  if (!vehicleRegistrationId.value)
    return
  _loadDetails.value = true
  //await delay(4000)
  const res = await apiVehicleRegistration.load(vehicleRegistrationId.value)
  if (_key.value !== key) {
    return
  }
  if (res) {
    _vehicleRegistration.value = res.vehicleRegistration
    _gdvMessageIds.value = res?.vehicleRegistration.gdvMessageIds?.split('|').filter(Boolean) ?? []
    _memos.value = res?.vehicleRegistration.memo ?? ""
  }
  _loadDetails.value = false
}


onMounted(async () => {
  await load();
})

async function onImport() {
  if (!_tempFileInfo.value || !_tempFileInfo.value.id)
    return;
  const res = await apiVehicleRegistration.addTempFile(_tempFileInfo.value.id, vehicleRegistrationId.value, _tempFileInfo.value.name, _tempFileInfo.value.fileName);
  if (res) {
    notificationService.success("Datei " + _tempFileInfo.value.name + " wurde gespeichert")
    _tempFileInfo.value = undefined
    _uploader.value?.clear()
    _uploadTempFile.value = false
    await load()
  }
}

function onTakePhoto() {
  _uploadTempFile.value = true;
  _camera.value = true
  _uploader.value?.takePhoto()
}

function onDelete(file: ListFile) {

  notificationService.showYesNo("Datei löschen", "Soll die Datei " + file.name + " wirklich gelöscht werden?", async () => {
    const res = await apiFileUtils.deleteFile(file?.id ?? "")
    if (res) {
      notificationService.success("Datei " + file.name + " wurde gelöscht")
      _tempFile.value = _tempFile.value.filter(f => f.id !== file.id)
    } else
      notificationService.error("Datei " + file.name + " konnte nicht gelöscht werden")
  })

}

async function onDownload(file: ListFile) {
  if (!file.personId)
    return;
  try {
    _spinner.show()
    const fileId = await apiFileUtils.initDownloadFile(file.id ?? "");
    if (fileId)
      await apiFile.downloadTempFile(fileId)

  } finally {
    _spinner.hide()
  }
}

async function onSave() {
  if (!_form.value?.validate()) {
    return
  }
  const obj = new VehicleRegistration();
  obj.id = _vehicleRegistration.value?.id
  obj.memo = _memo.value
  //obj.halterName = _vehicleRegistration.value?.halterName+"!!"


  const res = await apiVehicleRegistration.update(obj, "Memo")
  if (res) {
    notificationService.success("Bemerkung wurde gespeichert")
    await load()
    _editMemoVisible.value = false
  }
}

const _dialogLink = ref<InstanceType<typeof VehicleRegistrationLinkDialog> | null>(null)
const _dialogIgnore = ref<InstanceType<typeof SogDialog> | null>(null)

function onOpen(action: string) {
  if (action === "link")
    _dialogLink.value?.show()
  else if (action === "unlink")
    _dialogUnlink.value?.show()
  else
    _dialogIgnore.value?.show()
}

function onCancelLink(action: string) {
  if (action === "unlink") {
    _dialogUnlink.value?.hide()
    _reason.value = ""
  } else {
    _dialogIgnore.value?.hide()
    _reason.value = ""
  }

}

async function onOkUnLink() {

  if (!_reason.value) {
    notificationService.error("Bitte einen Grund eingeben")
    return
  }
  const res = await apiVehicleRegistration.insuranceLink(_vehicleRegistration.value?.id ?? "", _vehicleRegistration.value?.id ?? "", _reason.value, true)
  if (res) {
    notificationService.success("Zulassung erfolgreich unverknüpft")
    _reason.value = ""
    _dialogUnlink.value?.hide()
    await load()

  }
}

async function onOkIgnore() {

  if (!_reason.value) {
    notificationService.error("Bitte einen Grund eingeben")
    return
  }
  const res = await apiVehicleRegistration.ignore(_vehicleRegistration.value?.id ?? "", _reason.value)
  if (res) {
    notificationService.success("Zulassung erfolgreich ignoriert")
    _reason.value = ""
    _dialogIgnore.value?.hide()
    await load()

  }

}

async function onCreateInquiry(item?: SogDropDownButtonItem) {
  if (!item?.id || !_vehicleRegistration.value?.id) {
    return
  }
  const t_id = await apiRegistrationInquiry.create(_vehicleRegistration.value.id, item.id)
  if (t_id) {
    notificationService.success("Entwurf wurde angelegt und liegt unter Recherche-Mails")
    await load()
  }
}

function onPolicy() {
  if (_vehicleRegistration.value?.insuranceId) {
    _navigationStore.currentInsuranceId = _vehicleRegistration.value.insuranceId
  }
}


function onCancel() {
  _editMemoVisible.value = false

}

function onEditMemo() {
  _memo.value = _vehicleRegistration.value?.memo
  _editMemoVisible.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, { id: "page" }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { class: "sog-card-without-title" }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-shield",
                tooltip: "Versicherungskarte",
                onClick: onPolicy
              }, null, 512), [
                [_vShow, _vehicleRegistration.value?.insuranceId]
              ]),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-paperclip-plus",
                tooltip: "Anhang hinzufügen",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_uploadTempFile.value = true))
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-camera",
                tooltip: "Anhang fotografieren",
                onClick: onTakePhoto
              }),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-shield-link-variant",
                tooltip: "Verknüpfen",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onOpen('link')))
              }, null, 512), [
                [_vShow, !_vehicleRegistration.value?.insuranceId]
              ]),
              (_unref(_isRoot))
                ? _withDirectives((_openBlock(), _createBlock(SogCardActionDropDownButton, {
                    key: 0,
                    "mdi-icon": "mdi-email-plus",
                    items: _unref(registrationInquiryMailTypeItems),
                    onSelect: onCreateInquiry
                  }, null, 8, ["items"])), [
                    [_vShow, _vehicleRegistration.value?.id && !_vehicleRegistration.value.insuranceId && _vehicleRegistration.value.ignore !== 'Y']
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-shield-remove",
                tooltip: "Verknüpfung löschen",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onOpen('unlink')))
              }, null, 512), [
                [_vShow, _vehicleRegistration.value?.insuranceId]
              ]),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-close",
                tooltip: "Ignorieren",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onOpen('ignore')))
              }, null, 512), [
                [_vShow, _vehicleRegistration.value?.ignore==='Y' || !_vehicleRegistration.value?.insuranceId]
              ]),
              _createVNode(SogDialog, {
                ref_key: "_dialogIgnore",
                ref: _dialogIgnore,
                target: "#app",
                "dialog-buttons": _unref(SogDialogButtons).OkCancel,
                onClickOk: onOkIgnore,
                onClickCancel: _cache[5] || (_cache[5] = ($event: any) => (onCancelLink('ignore')))
              }, {
                default: _withCtx(() => [
                  _createVNode(SogTextBox, {
                    modelValue: _reason.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_reason).value = $event)),
                    multiline: true,
                    width: "100%",
                    placeholder: "Grund fürs Ignorieren"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["dialog-buttons"]),
              _createVNode(VehicleRegistrationLinkDialog, {
                ref_key: "_dialogLink",
                ref: _dialogLink,
                target: "#app",
                "vehicle-registration-id": _vehicleRegistration.value?.id,
                onLinked: load
              }, null, 8, ["vehicle-registration-id"]),
              _createVNode(SogDialog, {
                ref_key: "_dialogUnlink",
                ref: _dialogUnlink,
                target: "#app",
                "dialog-buttons": _unref(SogDialogButtons).OkCancel,
                onClickOk: onOkUnLink,
                onClickCancel: _cache[7] || (_cache[7] = ($event: any) => (onCancelLink('unlink')))
              }, {
                default: _withCtx(() => [
                  _createVNode(SogTextBox, {
                    modelValue: _reason.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_reason).value = $event)),
                    multiline: true,
                    width: "100%",
                    placeholder: "Grund fürs Löschen"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["dialog-buttons"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(VehicleRegistrationComponent, { data: _vehicleRegistration.value }, null, 8, ["data"])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_loadDetails.value]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadDetails.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(_isRoot) && _vehicleRegistration.value?.id && !_vehicleRegistration.value.insuranceId && _vehicleRegistration.value.ignore !== 'Y')
        ? (_openBlock(), _createBlock(VehicleRegistrationSuggestionComponent, {
            key: 0,
            "vehicle-registration-id": _vehicleRegistration.value.id,
            onChanged: load
          }, null, 8, ["vehicle-registration-id"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(TempFileFormComponent, {
        ref_key: "_uploader",
        ref: _uploader,
        modelValue: _tempFileInfo.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_tempFileInfo).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-upload",
                onClick: onImport
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" importieren ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _tempFileInfo.value]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Cancel,
                onClick: _cache[8] || (_cache[8] = ($event: any) => {_uploadTempFile.value=false;_camera.value=false})
              }, null, 8, ["kind"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]), [
        [_vShow, _uploadTempFile.value]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Bemerkungen", -1)
            ]))]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogFlexColumn, null, {
                default: _withCtx(() => [
                  _createVNode(MemoComponent, { memo: _memos.value }, null, 8, ["memo"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, !_loadDetails.value]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadDetails.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-pencil",
                tooltip: "Bearbeiten",
                onClick: onEditMemo
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, !_editMemoVisible.value]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(MemoEditComponent, {
                ref_key: "_form",
                ref: _form,
                modelValue: _memo.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_memo).value = $event))
              }, null, 8, ["modelValue"]), [
                [_vShow, _editMemoVisible.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Save,
                onClick: onSave
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Cancel,
                onClick: onCancel
              }, null, 8, ["kind"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _editMemoVisible.value]
      ]),
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("Gdv Nachrichten", -1)
            ]))]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogFlexColumn, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_gdvMessageIds.value, (data, i) => {
                    return (_openBlock(), _createBlock(GdvMessageIdComponent, {
                      key: i,
                      item: data
                    }, null, 8, ["item"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, !_loadDetails.value]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadDetails.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("Historie", -1)
            ]))]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(HistoryListComponent, { data: _history }, null, 8, ["data"])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_loadHistory.value]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadHistory.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _loadHistory.value || _history.length>0]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("Anhänge", -1)
            ]))]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_tempFile.value, (file) => {
            return _withDirectives((_openBlock(), _createBlock(SogCardContent, {
              key: file.id
            }, {
              default: _withCtx(() => [
                _createVNode(FileCardComponent, { file: file }, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActionButton, {
                      "mdi-icon": "mdi-delete",
                      tooltip: "Löschen",
                      onClick: ($event: any) => (onDelete(file))
                    }, null, 8, ["onClick"]),
                    _createVNode(SogCardActionButton, {
                      "mdi-icon": "mdi-download",
                      tooltip: "Download",
                      onClick: ($event: any) => (onDownload(file))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["file"])
              ]),
              _: 2
            }, 1024)), [
              [_vShow, !_loadFiles.value]
            ])
          }), 128)),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadFiles.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _loadFiles.value || _tempFile.value.length!==0]
      ])
    ]),
    _: 1
  }))
}
}

})